import ScrollReveal from 'scrollreveal'

var scrollRevealsApp = function() {
	// variables & binds here
    const body = document.body;

    var init = function() {
        handleScrollReveal();
	}

/* FUNCTIONS #######################################* */


    function handleScrollReveal() {
    	let options = {
    		duration: 850,
    		delay: 0,
            container: '.main-wrapper',
    	}

        let bannerOptions = {
            distance:   '50px',
            duration:   1500,
            interval:   100,
            opacity:    0,
            origin:     'bottom',
            easing:     'cubic-bezier(0.5, 0, 0, 1)'
        }

        let imgOptions = {
            distance:   '0px',
            duration:   750,
            opacity:    0,
            scale:      1.06,
            interval:   100,
            easing:     'cubic-bezier(0.5, 0, 0, 1)'
        }

        let imgFeatured = {
            duration: 450,
            opacity: 0,
            scale: 1.06,
            easing: 'cubic-bezier(0.5, 0, 0, 1)',
            delay: 300
        }

    	// Page heros
    	ScrollReveal().reveal( '.page-hero', options );
    	ScrollReveal().reveal( '.page-hero-video', options );
    	ScrollReveal().reveal( '.page-hero .sequenced', { distance: '30px', interval: 50, delay: 200 } );

    	// Animation for FP only
        if ( body.classList.contains('home') ) {
            // Header
            ScrollReveal().reveal('.header .sequenced', { interval: 50 } );

            // Banners
            ScrollReveal().reveal( 'section.green', bannerOptions );

            // Our solutions section
            ScrollReveal().reveal( '.featured-causes h5', { distance: '30px' } );
            ScrollReveal().reveal( '.featured-causes h2', { distance: '30px', delay: 200 } );
            ScrollReveal().reveal( '.grid-cause', imgOptions );

            // News section
            ScrollReveal().reveal('.featured-post h5', { distance: '30px' } );

            // Button
            ScrollReveal().reveal('.posts-button', { duration: 850, distance: '30px' } );

            // Supporter section
            ScrollReveal().reveal('.supporter img', imgFeatured);
            ScrollReveal().reveal( '.supporter h5', { distance: '30px', delay: 200 } );
            ScrollReveal().reveal( '.supporter blockquote', { distance: '30px', delay: 300 } );
            ScrollReveal().reveal( '.supporter .name', { distance: '30px', delay: 400 } );
            ScrollReveal().reveal( '.supporter .title', { distance: '30px', delay: 400 } );
            ScrollReveal().reveal( '.supporter .button', { duration: 850, distance: '30px', delay: 500 } );

            // Grid-half
            ScrollReveal().reveal( '.grid-half h2', { distance: '30px' } );
            ScrollReveal().reveal( '.grid-half p', { distance: '30px', delay: 200 } );
            ScrollReveal().reveal( '.grid-half a', { distance: '30px', delay: 400 } );
            ScrollReveal().reveal( '.grid-half img', {
                duration: 450,
                opacity: 0,
                easing: 'cubic-bezier(0.5, 0, 0, 1)',
                delay: 500
            } );

					// Text and media
					ScrollReveal().reveal('.text-and-media h2', { distance: '30px' });
					ScrollReveal().reveal('.text-and-media p', { distance: '30px', delay: 200 });
					ScrollReveal().reveal('.text-and-media a', { distance: '30px', delay: 400 });
					ScrollReveal().reveal('.text-and-media img', {
						duration: 450,
						opacity: 0,
						easing: 'cubic-bezier(0.5, 0, 0, 1)',
						delay: 500
					});
        }

        // Blog animations

        ScrollReveal().reveal('.featured-post .content', { distance: '30px', delay: 200 } );
        ScrollReveal().reveal('.featured-post .img', imgFeatured );
        ScrollReveal().reveal('.grid-post .img', imgOptions );
        ScrollReveal().reveal('.grid-post .content', {
            distance:   '10px',
            duration:   750,
            opacity:    0,
            interval:   50,
            origin:     'bottom',
            easing:     'cubic-bezier(0.5, 0, 0, 1)'
        })

        if ( body.classList.contains('blog') ) {
            ScrollReveal().reveal('section.blog-filters', {duration: 850, delay: 200 } );
        }
    }

return {init:init}
}();


document.addEventListener("DOMContentLoaded", function(){
    scrollRevealsApp.init();
});